<template>
  <div>
    <button @click="addTeam">add team</button>
    <button @click="resetTeams">reset Team</button>
    <div class="dropContainer">
      <div>
        <el-card>
          <div slot="header" class="clearfix">
            <span>No Team</span>
          </div>
          <drop :id='noTeam' class="drop" @drop="handleDrop(null, ...arguments)">
            <el-tag class="tag" v-for="user in noTeam" :key="user.id">
              <drag :transfer-data="{user}">{{ user.name }}</drag>
            </el-tag>
          </drop>
        </el-card>
      </div>
      <div v-for="team in teams" :key="team.id">
        <el-card>
          <div slot="header" class="clearfix">
            <span>{{team.manager}}</span>
            <el-popover
              placement="top"
              width="200"
              trigger="click">
              <div slot="default">
                <el-select  v-model="userSelect" value-key="id" @change="addManager" filterable placeholder="Select" style="width: 100%;">
                  <el-option class="userSelect"
                    v-for="user in users"
                    :key="user.id"
                    :label="user.name"
                    :value='`${user.id},${team.id}`'>
                  </el-option>
                </el-select>
              </div>
              <i slot="reference" class="el-icon-edit" style="float: right; padding: 3px 0" />
              <!-- <el-button slot="reference">Click to activate</el-button> -->
            </el-popover>
          </div>
          <drop :id='team.id' class="drop" @drop="handleDrop(team.id, ...arguments)">
            <el-tag class="tag" v-for="user in team.users" :key="user.id">
              <drag :transfer-data="{user,team}">{{ user.name }}</drag>
            </el-tag>
          </drop>
        </el-card>
      </div>
    </div>

    <!-- <div class='drag' v-for="user in team.none" :key="user.id">
      <drag class="drag" :transfer-data="{ user}">{{ user.name }}</drag>
    </div>
    <drop id="test" class="drop" @drop="handleDrop">
      <div class='drag' v-for="user in team" :key="user.id">
        <drag class="drag" :transfer-data="{ user}">{{ user.name }}</drag>
      </div>
    </drop> -->
  </div>
</template>
<script>
import {database} from '../main.js'
  export default {
    data () {
      return {
        draggable: 'drag th hdghfdghj',
        users: [],
        userSelect: [],
        teams: [],
        loading: false
      }
    },
    computed: {
      noTeam () {
        return this.users.filter(user => !user.teamId)
      }
    },
    methods: {
      handleDrop (id, data, event) {
        if (!id) return
        if (data.team) {
          this.removeFromTeam(data.user.id, data.team.id)
        }
        this.addToTeam(data.user.id, id)
        // database.ref(`users/${data.user.id}`).update({team: event.target.id})
      },
      addTeam () {
        console.log('clicked')
        const newTeam = database.ref(`/teams`).push()
        newTeam.set({test: 'test'})
      },
      async resetTeams () {
        let users = await database.ref(`/users`).once('value')
        users = users.val()
        const usersArray = Object.keys(users).map(key => database.ref(`/users/${key}`).update({teamId: null}))
        Promise.all(usersArray)
      },
      addManager (data) {
        console.log('clicked', data)
        const ids = data.split(',')
        database.ref(`/teams/${ids[1]}`).update({managerId: ids[0]})
        this.userSelect = []
      },
      removeFromTeam (userId, teamId) {
        database.ref(`/users/${userId}/teamId`).remove()
        database.ref(`/teams/${teamId}/users/${userId}`).remove()
      },
      addToTeam (userId, teamId) {
        database.ref(`/users/${userId}/teamId`).set(teamId)
        database.ref(`/teams/${teamId}/users/${userId}`).set(true)
        /* newMember.set({id: userId}) */
      },
      createTeams () {
        console.log('hello')
      }
    },
    async created () {
      database.ref('/users').on('value', async (snapshot) => {
        let users = snapshot.val()
        console.log(users)
        this.users = Object.keys(users).map(key => ({
          name: users[key].firstName + ' ' + users[key].lastName,
          id: key,
          teamId: users[key].teamId
        }))
        let teams = await database.ref('/teams').on('value', data => {
          teams = data.val()

          this.teams = Object.keys(teams).map(key => {
            let teamUsers = teams[key].users ? Object.keys(teams[key].users) : []
            const manager = teams[key].managerId ? this.users.find(user => user.id === teams[key].managerId).name : 'No Manager'
            teamUsers = teamUsers.map(userId => this.users.find(user => user.id === userId))
            return {
              manager,
              users: teamUsers,
              id: key
            }
          })
      })
      })
    }
  }
</script>
<style scoped>
.dropContainer {
  display: grid;
  grid-gap: 15px;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
}
.tag {
  width: 100%;
  margin-bottom: 10px;
}
.drop {
  width: calc(100% - 20px);
  font-family: sans-serif;
  height: 400px;
  overflow: scroll;
  background: white;
  position: relative;
  padding: 10px;
  text-align: center;
  vertical-align: top;
}

.drag {
  color: #fff;
  cursor: move;
  background: #777;
  border-right: 2px solid #555;
  border-bottom: 2px solid #555;
}
</style>



// WEBPACK FOOTER //
// src/components/Teams.vue